module.exports = __webpack_public_path__ + "static/portfolio-5-8a0d313ce1430f6dd4de4b4c3c43ee15.jpg";